// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBDmpF9uyT6CvzDw4yafQQliFoZ1KIy_FA",
  authDomain: "straps-60443.firebaseapp.com",
  projectId: "straps-60443",
  storageBucket: "straps-60443.firebasestorage.app",
  messagingSenderId: "260471468720",
  appId: "1:260471468720:web:425a934b8894418b4e8175",
  measurementId: "G-8GX5ZJYW0X"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

